'use strict';

exports.__esModule = true;

var isString = exports.isString = function isString(str) {
  return typeof str === 'string';
};

var checkAction = exports.checkAction = function checkAction(type) {
  return type.length === 2 && type.every(isString);
};

var parseToUppercase = exports.parseToUppercase = function parseToUppercase(str) {
  return str.replace(/([A-Z])/g, '_$1').toUpperCase();
};

var removeNamespace = exports.removeNamespace = function removeNamespace(str, NAMESPACE) {
  return str.replace(NAMESPACE + '_', '');
};

var toAsyncTypes = exports.toAsyncTypes = function toAsyncTypes(type) {
  return [type + '_REQUEST', type + '_RESPONSE'];
};